import React from "react"
import Editor from "@monaco-editor/react";
import { useContext } from "react";
import { JSONataEditorContext } from "../contexts/JSONataEditorContext";

export default function OutputJSONata() {

  const { output } = useContext(JSONataEditorContext)
  return <Editor
    defaultLanguage="json"
    theme="vs-light"
    value={output}
    options={{
      readOnly: true,
      lineNumbers: "off",
      minimap: { enabled: false }
    }}
  />


}
